import { SquadInvite } from "../../types/squads";

export const sendSquadInviteModel = (
  response: SquadInvite
): SquadInvite => response;
